import { Box, Button, ButtonProps, Stack, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import { ButtonWithLoading } from '@e3dc-react/shell/Elements/Buttons'
import { makeStyles } from 'tss-react/mui'
import { isNil } from 'lodash'

interface StyleProps {
  isLeftControlsActive: boolean
}
const useStyles = makeStyles<StyleProps>()((theme, props) => ({
  leftControls: {
    paddingBottom: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      paddingBottom: theme.spacing(0),
    },
  },
  rightButtons: {
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
    gap: theme.spacing(2),
  },
  stackContainer: {
    display: 'flex',
    flexDirection: props.isLeftControlsActive ? 'row' : 'column',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      flexDirection: props.isLeftControlsActive ? 'row' : 'row-reverse',
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      marginLeft: `-${theme.spacing(4)}`,
      marginRight: `-${theme.spacing(4)}`,
    },
    padding: theme.spacing(4),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
}))

export interface ActionProps {
  label: string
  onClick?: () => void | Promise<void>
  disabled?: boolean
  variant?: ButtonProps['variant']
  color?: ButtonProps['color']
  dataQa?: string
}

export interface DrawerActionProps {
  isLoading?: boolean
  leftControls?: React.ReactNode
  secondaryAction: ActionProps
  primaryAction: ActionProps
}

/*
 * This component can be used for having responsive dialog actions
 */
const ResponsiveModalDrawerActions: React.FC<DrawerActionProps> = ({ isLoading, leftControls, secondaryAction, primaryAction }) => {
  const isLeftControlsActive = !isNil(leftControls)
  const { classes } = useStyles({ isLeftControlsActive })
  const { breakpoints } = useTheme()
  const fullWidthButtons = useMediaQuery(breakpoints.down('sm'))

  return (
    <Stack className={classes.stackContainer}>
      {leftControls && <Box className={classes.leftControls}>{leftControls}</Box>}
      <Stack className={classes.rightButtons}>
        <Button
          type="button"
          variant={secondaryAction.variant ? secondaryAction.variant : 'outlined'}
          size="large"
          color={secondaryAction.color ? secondaryAction.color : 'inherit'}
          disabled={secondaryAction.disabled}
          onClick={secondaryAction.onClick}
          fullWidth={fullWidthButtons}
          data-qa={secondaryAction.dataQa}
        >
          {secondaryAction.label}
        </Button>
        <ButtonWithLoading
          variant={primaryAction.variant ? primaryAction.variant : 'contained'}
          fullWidth={fullWidthButtons}
          size="large"
          color={primaryAction.color ? primaryAction.color : 'primary'}
          isLoading={isLoading}
          onClick={primaryAction.onClick}
          label={primaryAction.label}
          disabled={primaryAction.disabled}
          dataQa={primaryAction.dataQa}
        />
      </Stack>
    </Stack>
  )
}

export default ResponsiveModalDrawerActions
